import { useCallback, useMemo, useState } from 'react'

import ConfettiBurst from '../components/confetti-burst/ConfettiBurst'
import {
  CelebrationContextValue,
  CelebrationProviderProps,
} from './celebration-context-types'
import { CelebrationContext } from './use-celebration'

/**
 * Provides a single `celebrate()` action that any descendant can call to
 * fire a confetti burst from the centre of the viewport. Mounts the
 * `ConfettiBurst` overlay once at the root so multiple consumers don't
 * spawn duplicate overlays.
 *
 * @param {CelebrationProviderProps} props
 * @returns {JSX.Element}
 */
const CelebrationProvider = ({
  children,
}: CelebrationProviderProps): JSX.Element => {
  const [trigger, setTrigger] = useState<number>(0)

  const celebrate = useCallback((): void => {
    setTrigger(Date.now())
  }, [])

  const value = useMemo<CelebrationContextValue>(
    () => ({ celebrate, trigger }),
    [celebrate, trigger],
  )

  return (
    <CelebrationContext.Provider value={value}>
      {children}
      <ConfettiBurst trigger={trigger} />
    </CelebrationContext.Provider>
  )
}

export { CelebrationProvider }
